import { ITimezone } from "react-timezone-select";
import { components, OptionProps, SingleValueProps, GroupBase } from "react-select";

function formatLabel(data: ITimezone) {
  if (typeof data === "string") return data;
  const { label, value } = data;
  return `${label} (${value})`;
}

export function CustomSingleValue(props: SingleValueProps<ITimezone, boolean, GroupBase<ITimezone>>) {
  const { data } = props;
  return (
    <components.SingleValue {...props}>
      {formatLabel(data)}
    </components.SingleValue>
  );
}

export function CustomOption(props: OptionProps<ITimezone, boolean, GroupBase<ITimezone>>) {
  const { data } = props;
  return (
    <components.Option {...props}>
      {formatLabel(data)}
    </components.Option>
  );
}
